import { render, staticRenderFns } from "./TextSendingOptions.vue?vue&type=template&id=63214e65&scoped=true&lang=pug"
import script from "./TextSendingOptions.vue?vue&type=script&lang=js"
export * from "./TextSendingOptions.vue?vue&type=script&lang=js"
import style0 from "./TextSendingOptions.vue?vue&type=style&index=0&id=63214e65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63214e65",
  null
  
)

export default component.exports